import { rankWith, schemaMatches } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { get } from 'lodash';
import { currencyFormat } from '../../../../../utils/currency';
import { fromJS } from '../../../../../utils/date';
import { currencySymbol } from '../../../../../utils/DynamicForms';
import { FormItem } from '../../../../../controls/FormItem';
import { Select } from '../../../../../controls/Select';
import { FieldProps, WithDynamicFormContext } from '../WithDynamicFormContext';
import './style.scss';

const SelectControl = ({
  data,
  handleChange,
  handleRemove,
  handleBlur,
  path,
  label,
  schema,
  formData,
  required,
  uischema,
  disabled,
  optionalMessage,
}: FieldProps) => {
  const { options } = uischema;
  const moreInfo = uischema.options?.moreInfo;
  const dependenciesToChange = uischema?.options?.dependenciesToChange;

  const currency = currencySymbol(
    formData,
    uischema.options?.dependencies?.[0],
  );

  return (
    <FormItem
      label={label as string}
      required={required}
      classes="tru-select-input-control"
      moreInfo={moreInfo}
      optionalMessage={optionalMessage}
    >
      <div>
        <Select
          onBlur={() => handleBlur(path)}
          disabled={disabled}
          value={data}
          onChange={(value) => {
            if (schema.type === 'number') {
              handleChange(path, Number(value));
            } else {
              if (!!value) {
                handleChange(path, value);
              } else {
                handleRemove(path);
              }
            }
            if (dependenciesToChange && get(formData, dependenciesToChange[1]))
              handleChange(
                dependenciesToChange[0],
                fromJS(new Date(get(formData, dependenciesToChange[1])))
                  //@ts-ignore
                  .plus({ months: value.toString() })
                  .toFormat('yyyy-MM-dd'),
              );
          }}
        >
          {schema.oneOf?.map((opt) => (
            <option key={`select-option-${opt.const}`} value={opt.const}>
              {options?.currency && Number(opt.title)
                ? currencyFormat(Number(opt.title), currency)
                : opt.title}
            </option>
          ))}
        </Select>
        {schema.description && (
          <p className="description margin-bottom">{schema.description}</p>
        )}
      </div>
    </FormItem>
  );
};

export const SelectControlOneOfEntry = {
  tester: rankWith(
    10,
    schemaMatches((schema) => {
      return !!schema.oneOf;
    }),
  ),
  renderer: withJsonFormsControlProps(WithDynamicFormContext(SelectControl)),
};
